import { combineReducers } from 'redux';
import baseState from './reducer';
import machineInventoryExportReducer from './cards/InventoryExportCard/reducer';
import machineUsageExportReducer from './cards/MachineUsageExportCard/reducer';
import roboticMowerUsageExportReducer from './cards/RoboticMowerUsageExportCard/reducer';

export default combineReducers({
  baseState,
  machineUsage: machineUsageExportReducer,
  machineInventory: machineInventoryExportReducer,
  roboticMowerUsage: roboticMowerUsageExportReducer,
});
